import type { PresenceStatus } from '@callzone/shared';
import { getBaseUrl } from '../lib/api';

interface Props {
  name: string;
  color: string;
  size?: number;
  presence?: PresenceStatus;
  /** Id de quem e o avatar. Sem ele, cai na inicial sobre a cor. */
  userId?: string;
  /**
   * Quantas vezes a foto foi trocada. 0 = sem foto. Vai na URL para o navegador
   * buscar a nova em vez de servir a anterior do cache — a resposta e marcada
   * como imutavel justamente porque a versao muda quando o conteudo muda.
   */
  avatarVersion?: number;
}

/** Avatar: a foto da pessoa, ou a inicial dela sobre a cor da conta. */
export function Avatar({ name, color, size = 32, presence, userId, avatarVersion }: Props) {
  const temFoto = !!userId && !!avatarVersion && avatarVersion > 0;

  return (
    <div
      className="avatar"
      style={{ width: size, height: size, background: color, fontSize: Math.round(size * 0.42) }}
    >
      {temFoto ? (
        <img
          src={`${getBaseUrl()}/api/usuarios/${userId}/foto?v=${avatarVersion}`}
          alt=""
          className="avatar-foto"
          loading="lazy"
        />
      ) : (
        (name.trim().charAt(0).toUpperCase() || '?')
      )}
      {presence && <span className={`presence ${presence}`} />}
    </div>
  );
}
